module.exports = __webpack_public_path__ + "img/wx@2x.4df71215.png";